module.exports = __webpack_public_path__ + "media/assets/codoo99-75ba223945401347f49b526f7863e584.png";